import styled from 'styled-components'
import { get } from '../../utils/theme'

export const H4 = styled.h4`
  ${get('styles.h4')};
`
